module.exports = __webpack_public_path__ + "static/media/images-cl_logo3.77a8c8c5.png";